/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name Magnifier
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE4LjUgMTFhNy41IDcuNSAwIDExLTE1IDAgNy41IDcuNSAwIDAxMTUgMG0tMS42ODggNi44NzJhOSA5IDAgMTExLjA2LTEuMDZsMi44OTggMi44OThhLjc1Ljc1IDAgMTEtMS4wNiAxLjA2eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+) - https://fondue-components.frontify.com/?path=/story/icons_icons--default&args=iconName:magnifier
 * @see https://fondue-components.frontify.com/?path=/story/icons_icons--default - Documentation
 */
export const IconMagnifier = createFondueIcon('Magnifier', [["path",{"fill":"currentColor","fill-rule":"evenodd","d":"M18.5 11a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0m-1.688 6.872a9 9 0 111.06-1.06l2.898 2.898a.75.75 0 11-1.06 1.06z","clip-rule":"evenodd"}]]);
